import React, { useEffect, useState } from 'react'
import './carousel.css'
import './Tabs.css';
import axios from 'axios';
import configData from './config.json';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faRefresh } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useNavigate } from 'react-router-dom';

library.add(faRefresh);



// const items = [{ "number": "10", "collection": "starwars", "table": "collectablesItems", "dateadded": "2023-04-23 13:40:46.421660", "price": "10", "description": "Sand Explorer", "name": "Yawas" }, { "number": "", "collection": "starwars", "table": "collectablesItems", "dateadded": "2023-04-23 14:39:55.391655", "price": "10", "description": "Vader's Elite Soldier ", "name": "Snow Tropper" }, { "number": "83", "collection": "starwars", "table": "collectablesItems", "dateadded": "2023-04-23 11:31:48.898090", "price": "90", "description": "R2D2 Last 17", "name": "R2D2 Saber" }, { "number": "96", "collection": "starwars", "table": "collectablesItems", "dateadded": "2023-04-23 13:39:24.064911", "price": "151", "description": "Jabbas Henchman ", "name": "Yak Face" }, { "number": "14", "collection": "starwars", "table": "collectablesItems", "dateadded": "2023-04-23 07:04:11.908366", "price": "10", "description": "Canteener", "name": "Hammer Head" }, { "number": "", "collection": "starwars", "table": "collectablesItems", "dateadded": "2023-04-23 08:06:52.367819", "price": "20", "description": "Jedi Knight ", "name": "Yoda" }, { "number": "13", "collection": "starwars", "table": "collectablesItems", "dateadded": "2023-04-23 07:03:33.565098", "price": "10", "description": "Debt Collector", "name": "Gredo" }, { "number": "", "collection": "starwars", "table": "collectablesItems", "dateadded": "2023-04-23 08:06:18.933894", "price": "200", "description": "Canteen Customer", "name": "Blue Snaggletooth" }, { "number": "21", "collection": "starwars", "table": "collectablesItems", "dateadded": "2023-04-23 07:06:10.465766", "price": "15", "description": "Bounty Hunter", "name": "Boba Fett" }, { "number": "6", "collection": "starwars", "table": "collectablesItems", "dateadded": "2023-04-23 07:04:33.992394", "price": "10", "description": "Sith Lord", "name": "Darth Vader" }, { "number": "1", "collection": "starwars", "table": "collectablesItems", "dateadded": "2023-04-23 06:45:51.395920", "price": "10", "description": "Jedi Knight", "name": "Luke" }, { "number": "85", "collection": "starwars", "table": "collectablesItems", "dateadded": "2023-04-23 13:38:34.198807", "price": "50", "description": "Last 17", "name": "Han in Caronite" }];

const MyCarousel = (props) => {
  const navigate = useNavigate();
  const { show, collection } = props

  const [currentIndex, setCurrentIndex] = useState(0);
  const [length, setLength] = useState(null)

  const [touchPosition, setTouchPosition] = useState(null)

  // Set the length to match current children from props
  // useEffect(() => {
  //   setLength(children.length)
  // }, [children])

  const next = () => {
    if (currentIndex < (length - show)) {
      setCurrentIndex(prevState => prevState + 1)
    }
  }

  const prev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(prevState => prevState - 1)
    }
  }

  const handleTouchStart = (e) => {
    const touchDown = e.touches[0].clientX
    setTouchPosition(touchDown)
  }

  const handleTouchMove = (e) => {
    const touchDown = touchPosition

    if (touchDown === null) {
      return
    }

    const currentTouch = e.touches[0].clientX
    const diff = touchDown - currentTouch

    if (diff > 5) {
      next()
    }

    if (diff < -5) {
      prev()
    }

    setTouchPosition(null)
  }

  const backGrColors = ['blue', 'red', 'orange', 'yellow'];

  const [showModal, setShowModal] = useState(false);
  const [input1Value, setInput1Value] = useState('');
  const [input2Value, setInput2Value] = useState('');


  const handleClick = (input1, input2) => {
    // setInput1Value(input1);
    // setInput2Value(input2);
    // setShowModal(true);

    navigate('/' + input2 + '/' + input1);
  };

  const [children, setData] = useState([]);
  function fetchData() {
    // const url = "https://collectables.ashworthcloud.com/images/collection_staged.json";
    const url = "images/collection_staged.json";
    axios.get(url)
      .then(response => {
        try {
          setData(JSON.parse(response.data));
        }
        catch (error) {
          console.log('error1');
          var jsonObj = response.data;

          setData(jsonObj);
          console.log(error);
        }
        // console.log(typeof data);
      })
      .catch(error => {
        console.log('error2');
        console.log(error);

      });
  }

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    var i = 0;
    children.map((item, index) => {
      if (item.collection === collection) {
        i++;
      }
    });
    setLength(i);
    setCurrentIndex(0);

  }, [collection, children]);

  function handleRefresh() {
    fetchData();
  }


  return (
    <div>
      <FontAwesomeIcon icon="refresh" onClick={handleRefresh} />
      <div className="carousel-container">
        <div className="carousel-wrapper">
          {/* You can alwas change the content of the button to other things */}
          {
            currentIndex > 0 &&
            <button onClick={prev} className="left-arrow">
              &lt;
            </button>
          }
          <div
            className="carousel-content-wrapper"
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
          >
            <div
              className={`carousel-content collection show-${show}`}
              style={{ transform: `translateX(-${currentIndex * (100 / show)}%)` }}
            >
              {children.map((item, index) => {
                if (item.collection === collection) {
                  return <div key={item.name} className="collection-item" onClick={() => handleClick(item.name, item.collection)}>
                    <div className={"card " + backGrColors[(index % 4)]}>
                      <img
                        className="d-block w-100"
                        src={"https://collectables.ashworthcloud.com/images/collection/" + collection + "/" + item.name + ".jpg"}
                        alt={item.name}
                      />
                      <div className="card-body">
                        <h5 className="card-title">{item.name}</h5>
                        <p className="card-text">{item.description ? item.description : ''}</p>
                      </div>
                    </div>
                  </div>
                } else {
                  return null;
                }
              })}
            </div>
          </div>
          {/* You can alwas change the content of the button to other things */}
          {
            currentIndex < (length - show) &&
            <button onClick={next} className="right-arrow">
              &gt;
            </button>
          }
        </div>
      </div>
    </div>
  )
}

export default MyCarousel;